import {
  STATE_STATUS,
  FETCH_CCFP_SUMMARY_FAILED,
  SET_CCFP_SUMMARY,
  FETCH_CCFP_SUMMARY_REQ,
  WITHDRAW_CCFP_MONEY,
  WITHDRAW_CCFP_MONEY_SUCCESS,
  WITHDRAW_CCFP_MONEY_FAILED,
  FETCH_CCFP_LANDING_PAGE,
  FETCH_CCFP_LANDING_PAGE_SUCCESS,
  FETCH_CCFP_LANDING_PAGE_ERROR,
  FETCH_PASSBOOK,
  FETCH_PASSBOOK_SUCCESS,
  FETCH_PASSBOOK_ERROR,
} from "./actionTypes";

const initialState = {
  isFetching: true,
  ccfpSummary: {},
  error: null,

  withdrawStatus: STATE_STATUS.NOT_CREATED,
  withdrawData: null,
  withdrawError: null,

  landingFirstLoad: true,
  pageDetails: null,
  pageDetailsStatus: STATE_STATUS.UNFETCHED,
  pageDetailsError: null,

  allTransactions: [],
  passbookStatus: STATE_STATUS.UNFETCHED,
  passbookError: null,

  isFirstLoad: true,
};
export const actions = {
  // SUMMARY ACTIONS
  fetchCCFPSummary: () => ({ type: FETCH_CCFP_SUMMARY_REQ }),
  setCCFPSummary: (data) => ({ type: SET_CCFP_SUMMARY, payload: { data } }),
  fetchCCFPFailed: (error) => ({
    type: FETCH_CCFP_SUMMARY_FAILED,
    payload: { error },
  }),

  // LANDING PAGE ACTIONS
  fetchLanding: () => ({ type: FETCH_CCFP_LANDING_PAGE }),
  fetchLandingSuccess: (data) => ({
    type: FETCH_CCFP_LANDING_PAGE_SUCCESS,
    payload: data,
  }),
  fetchLandingError: (error) => ({
    type: FETCH_CCFP_LANDING_PAGE_ERROR,
    payload: { error },
  }),

  // TRANSACTIONS

  fetchPassbook: () => ({ type: FETCH_PASSBOOK }),
  fetchPassbookSuccess: (data) => ({
    type: FETCH_PASSBOOK_SUCCESS,
    payload: { data },
  }),
  fetchPassbookError: (error) => ({
    type: FETCH_PASSBOOK_ERROR,
    payload: { error },
  }),

  // WITHDRAW ACTIONS
  withdrawMoney: (payload) => ({ type: WITHDRAW_CCFP_MONEY, payload }),
  withdrawMoneySuccess: (data) => ({
    type: WITHDRAW_CCFP_MONEY_SUCCESS,
    payload: { data },
  }),
  withdrawMoneyFailed: (error) => ({
    type: WITHDRAW_CCFP_MONEY_FAILED,
    payload: {
      error,
    },
  }),
};

const ccfpReducer = (state = initialState, action) => {
  switch (action.type) {
    // summary
    case FETCH_CCFP_SUMMARY_REQ:
      return {
        ...state,
        isFetching: true,
      };
    case SET_CCFP_SUMMARY:
      return {
        isFetching: false,
        error: false,
        ccfpSummary: action.payload.data,
        isFirstLoad: false,
      };
    case FETCH_CCFP_SUMMARY_FAILED:
      return {
        ...state,
        ccfpSummary: {},
        isFetching: false,
        error: action.payload.error,
      };
    // landing page related
    case FETCH_CCFP_LANDING_PAGE:
      return {
        ...state,
        pageDetailsStatus: STATE_STATUS.FETCHING,
      };
    case FETCH_CCFP_LANDING_PAGE_SUCCESS:
      return {
        ...state,
        landingFirstLoad: false,
        pageDetailsStatus: STATE_STATUS.FETCHED,
        pageDetails: action.payload.data,
        pageDetailsError: null,
      };
    case FETCH_CCFP_LANDING_PAGE_ERROR:
      return {
        ...state,
        pageDetailsStatus: STATE_STATUS.FETCH_FAILED,
        pageDetails: {},
        pageDetailsError: action.payload.error,
      };

    // transactions
    case FETCH_PASSBOOK:
      return {
        ...state,
        passbookStatus: STATE_STATUS.FETCHING,
      };
    case FETCH_PASSBOOK_SUCCESS:
      return {
        ...state,
        passbookStatus: STATE_STATUS.FETCHED,
        allTransactions: action.payload.data,
      };
    case FETCH_PASSBOOK_ERROR:
      return {
        ...state,
        allTransactions: [],
        passbookStatus: STATE_STATUS.FETCH_FAILED,
      };
    // withdraw related actions
    case WITHDRAW_CCFP_MONEY:
      return {
        ...state,
        withdrawStatus: STATE_STATUS.CREATING,
      };
    case WITHDRAW_CCFP_MONEY_SUCCESS:
      return {
        ...state,
        withdrawStatus: STATE_STATUS.CREATED,
        withdrawData: action.payload.data,
        withdrawError: null,
      };
    case WITHDRAW_CCFP_MONEY_FAILED:
      return {
        ...state,
        withdrawStatus: STATE_STATUS.CREATE_FAILED,
        withdrawData: {},
        withdrawError: action.payload.error,
      };

    default:
      return state;
  }
};
ccfpReducer.initialState = initialState;
export default ccfpReducer;
